import { Injectable } from '@angular/core';
import { CalculationBaseFormFactory } from '../../../base-form/form/base-form/calculation-base-form.factory';
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class SalaryDividendFormFactory extends CalculationBaseFormFactory {

  constructor(protected readonly formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = SalaryDividendOptions;
  }
}
